// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=1480-23229
// Component: SelectedCar
// Shows the selected car type with optional options as pills and an edit button
// States: normal | disabled (opacity-38)

import classnames from 'classnames'
import { Icon, Pill } from '~/components'
import SummaryIcon from '~/components/ui/SummaryIcon'
import { getCarType } from '~/utils/data'

export default function SelectedCar({ serviceType, options, onEdit, disabled }) {
  const carType = getCarType(serviceType)

  return (
    <div className={classnames('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]')}>
      {/* Car image — 44px clip container */}
      <div className="shrink-0 size-11 overflow-hidden flex items-center justify-center">
        <SummaryIcon id={serviceType} />
      </div>

      {/* Text + options */}
      <div className="flex-1 flex flex-col items-start min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">
          {carType?.title}
        </span>
        {options?.length > 0 && (
          <div className="flex gap-1 flex-wrap mt-0.5">
            {options.map((option, index) => (
              <Pill key={index} text={option} type="user-choice" />
            ))}
          </div>
        )}
      </div>

      {onEdit && !disabled && (
        <button type="button" onClick={onEdit} className="shrink-0 p-2 -mr-2" aria-label="Ändra biltyp">
          <Icon id="pen" />
        </button>
      )}
    </div>
  )
}
